import model from 'api'
import * as types from 'mutation-types'
import { getSessionStorage, setSessionStorage } from 'utils/storage'

const state = {
  list: [],
  params: getSessionStorage('system_list_params') || {
    systemType: '',
    name: '',
    username: ''
  },

  loadingList: false
}

const getters = {}

const mutations = {
  [types.SYSTEM_SET_LIST] (state, list) {
    state.list = list
  },
  [types.SYSTEM_SET_LOADING_LIST] (state, loading) {
    state.loadingList = loading
  },
  [types.SYSTEM_UPDATE_PARAMS] (state, data) {
    state.params = Object.assign(state.params, data)
  }
}

const actions = {
  async getList ({ commit, state }) {
    try {
      commit(types.SYSTEM_SET_LOADING_LIST, true)
      const list = await model.System.getList(state.params)
      commit(types.SYSTEM_SET_LIST, list)
    } catch (e) {
      commit(types.SYSTEM_SET_LIST, [])
    } finally {
      setSessionStorage('system_list_params', state.params)
      commit(types.SYSTEM_SET_LOADING_LIST, false)
    }
  },
  async setParams ({ commit, dispatch }, data) {
    commit(types.SYSTEM_UPDATE_PARAMS, data)
    await dispatch('getList')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
